<div
  class="container-fluid receipt-upload-modal d-flex flex-col align-items-center justify-center"
  style="height: 100vh"
  >
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12">
      @if (fileuploadState.isPending()) {
        <app-slim-spinner></app-slim-spinner>
      }
    </div>
  </div>
  @if (!fileuploadState.isPending()) {
    @if (isfileUploadState) {
      <div class="row mb-3">
        <div class="col-12 col-sm-12 col-md-12">
          <span class="title mb-6">
            {{ modalTitle }}
          </span>
        </div>
      </div>
      <div class="row">
        <div
          class="col-12 col-sm-12 col-md-12 file-outer-container mb-10"
          appFileDragAndDropV1
          (fileDropped)="onFileDropped($event)"
          (click)="dropReceiptFile.click()"
          >
          <div class="file-inner-container">
            @if (!fileList.length) {
              <div class="upload-image d-flex justify-center">
                <img
                  src="/assets/svg/expense-drop-receipt-whatsapp.svg"
                  class="upload-file-expense"
                  alt="file upload icon"
                  />
              </div>
              <div class="upload-expense-title my-1">
                <span style="text-decoration: underline">Click to Upload</span>
                or drag and drop
              </div>
              <div class="upload-expense-subtitle">
                Max file size 5MB | JPEG, PNG or PDF files are allowed
              </div>
            }
            <input
              #dropReceiptFile
              type="file"
              style="display: none"
              (change)="uploadFile($event)"
              />
            @if (fileList.length) {
              <div class="uploaded-file">
                <span>{{ this.fileList[0]?.name }}</span>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 pb-10 modal-sm-footer">
          <div class="col-12 col-sm-12 col-md-12 text-center">
            <button
              mat-flat-button
              color="primary"
              type="button"
              (click)="attachFile()"
              [disabled]="!fileList.length"
              >
              Attach
            </button>
          </div>
        </div>
      </div>
    } @else {
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12">
          <div class="d-flex justify-center mb-3">
            <img
              src="assets/svg/file-upload-success-whatsapp.svg"
              alt="Success"
              />
          </div>
          <p class="font-size-14 font-medium text-center text-success">
            <strong> File Uploaded Successfully! </strong>
          </p>
        </div>
      </div>
    }
  }
</div>
